import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useSeo } from "../../hooks";

import AccountLogin from "../../components/Layout/Sidebar/Account/AccountLogin";

interface Props {}

const HomeLogin: React.FC<Props> = () => {
    useSeo({
        title: "Login - Oberin",
        description: "Log in to your Oberin account.",
        robots: "noindex,nofollow",
    });

    const history = useHistory();
    const closePopup = useCallback(() => {
        history.push("/home");
    }, [history]);

    return <AccountLogin open={true} closePopup={closePopup} />;
};

export default HomeLogin;
